module.exports = require('crypto').randomBytes



//////////////////
// WEBPACK FOOTER
// ./~/randombytes/index.js
// module id = 43
// module chunks = 0 1 2 3